import {createSlice, type PayloadAction} from "@reduxjs/toolkit";

export interface ISemanticSearchModalState {
    isSemanticSearchOpen: boolean;
    hasConversation: boolean;
}

const initialState: ISemanticSearchModalState = {
    isSemanticSearchOpen: false,
    hasConversation: false
};

export const semanticSearchModalSlice = createSlice({
    name: "semanticSearchModal",
    initialState,
    reducers: {
        openSemanticSearchModal: (state) => {
            state.isSemanticSearchOpen = true;
        },
        closeSemanticSearchModal: (state) => {
            state.isSemanticSearchOpen = false;
        },
        setSemanticSearchHasConversation: (state, action: PayloadAction<boolean>) => {
            state.hasConversation = action.payload;
        }
    }
});

export const {openSemanticSearchModal, closeSemanticSearchModal, setSemanticSearchHasConversation} = semanticSearchModalSlice.actions;
import {createSlice, type PayloadAction} from "@reduxjs/toolkit";

export interface ISemanticSearchModalState {
    isSemanticSearchOpen: boolean;
    hasConversation: boolean;
}

const initialState: ISemanticSearchModalState = {
    isSemanticSearchOpen: false,
    hasConversation: false
};

export const semanticSearchModalSlice = createSlice({
    name: "semanticSearchModal",
    initialState,
    reducers: {
        openSemanticSearchModal: (state) => {
            state.isSemanticSearchOpen = true;
        },
        closeSemanticSearchModal: (state) => {
            state.isSemanticSearchOpen = false;
        },
        setSemanticSearchHasConversation: (state, action: PayloadAction<boolean>) => {
            state.hasConversation = action.payload;
        }
    }
});

export const {openSemanticSearchModal, closeSemanticSearchModal, setSemanticSearchHasConversation} = semanticSearchModalSlice.actions;
